import { useMutation, useQuery } from '@tanstack/react-query';

import { ACTIVITY_TYPE } from '@/consts/Activity';
import { API_ENDPOINT } from '@/config/endpoint';
import { isModalNumber } from '@/features/Discovery/discovery.state';
import { useAtomValue } from 'jotai';
import { useParams } from 'next/navigation';

export const useGetContentDetail = () => {
  const { id: paramId } = useParams();
  const modalId = useAtomValue(isModalNumber);
  const id = +paramId || modalId;

  return useQuery(
    ['discoverys', id],
    () => API_ENDPOINT.discovery.getContentDetail(id),
    {
      enabled: id !== 0,
      staleTime: 60000,
    }
  );
};

export const useGetRelatedContent = () => {
  const { id: paramId } = useParams();
  const modalId = useAtomValue(isModalNumber);
  const id = +paramId || modalId;

  return useQuery(
    ['discoverys', id, 'related'],
    () => API_ENDPOINT.discovery.getRelatedContent(id),
    {
      staleTime: 60000,
      enabled: id !== 0,
      suspense: true,
    }
  );
};

export const useDeleteBookmarkContent = () => {
  return useMutation((id: number) =>
    API_ENDPOINT.discovery.deleteBookmarkItem(id)
  );
};

export const useAddBookmarkContent = () => {
  return useMutation((id: number) =>
    API_ENDPOINT.discovery.addBookmarkItem(id)
  );
};

export const useUpdateContentLikeCount = (refetch) => {
  return useMutation(
    ({ id, like }: { id: number; like: boolean }) =>
      API_ENDPOINT.discovery.updateContentLikeCount(id, like),
    {
      onSettled: () => refetch(),
    }
  );
};

export const useGetDiscussionDataInDiscovery = (
  id: string,
  discussion_group_id?: string
) => {
  return useQuery(
    ['discussions', id],
    () => API_ENDPOINT.discussion.getTopicDetail(id, discussion_group_id),
    {
      enabled: !!id,
    }
  );
};

export const useGetDiscussionCommentDataInDiscovery = (id: string) => {
  return useQuery(
    ['discussions', 'comment', id],
    () => API_ENDPOINT.comment.getCommentList(ACTIVITY_TYPE.quiz, id),
    {
      enabled: !!id,
    }
  );
};

export const useGetDiscussionQuizDataInDiscovery = (
  id: string,
  mount: any,
  setAlreadySolved: any
) => {
  return useQuery(
    ['discussions', 'quiz', id],
    () => API_ENDPOINT.discussion.getQuiz(id),
    {
      enabled: !!id,
      onSuccess: (data) => {
        if (mount.current && data?.item?.my_vote_option_id) {
          setAlreadySolved(true);
        }
        mount.current = false;
      },
    }
  );
};
